import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AppDispatch, RootState } from "store/store";
import { getDashboardStates } from "store/actions/dashboard-action";
import { getUserDetail } from "store/actions/user-action";
import { format } from "date-fns";


export default () => {
    const navigate = useNavigate();
    const dispatch: AppDispatch = useDispatch();

    const states = useSelector((state: RootState) => state.dashboard?.states);
    const user = useSelector((state: RootState) => state.common?.user);

    const [fromDate, setFromDate] = useState(null)
    const [toDate, setToDate] = useState(null)

    const getDashboardData = (from: Date | null, to: Date | null) => {
        const params = {
            fromDate: from ? format(from, "yyyy-MM-dd") : "",
            toDate: to ? format(to, "yyyy-MM-dd") : "",
        }
        dispatch(getDashboardStates(params));
    }

    useEffect(() => {
        getDashboardData(null, null)
        dispatch(getUserDetail(user))
    }, []);

    const onFilter = () => {
        getDashboardData(fromDate, toDate)
    }

    const onReset = () => {
        setFromDate(null)
        setToDate(null)
        getDashboardData(null, null)
    }

    return {
        states,
        navigate,
        fromDate,
        setFromDate,
        toDate,
        setToDate,
        onFilter,
        onReset
    };
};
